"use client";
import { jsx } from "react/jsx-runtime";
import { TimePickerColumns } from "./time-picker-columns.js";
import { TimePickerSelect } from "./time-picker-select.js";
const MAX_FLAT_OPTIONS = 288;
const TimePicker = (props)=>{
    const { minuteInterval = 15, variant } = props;
    const totalOptions = 60 / minuteInterval * 24;
    const useColumns = 'columns' === variant || !variant && totalOptions > MAX_FLAT_OPTIONS;
    if (useColumns) return /*#__PURE__*/ jsx(TimePickerColumns, {
        ...props
    });
    return /*#__PURE__*/ jsx(TimePickerSelect, {
        ...props
    });
};
export { TimePicker };
